import { render, staticRenderFns } from "./widget_at_a_glance.vue?vue&type=template&id=c31166f8&"
import script from "./widget_at_a_glance.vue?vue&type=script&lang=js&"
export * from "./widget_at_a_glance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports